import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import { ReportHeading } from './common/ReportHeading'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './reportId'
import * as lb from './reportLables'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import { Box, Button, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Table } from '@mui/material'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { getBranchList } from '../../../store/common/common_action'
import { getBranchWiseCollectionData, getOwnChildBranches } from '../../../store/reports/reports_action'
import DropDownMultiSelect from '../../common/dropDownMultiSelect'
import { appendToUrl, focusElemnt, isEmpty, navigation2, navigation3 } from '../../common/helper'
import Alert from '../../common/alert'
import * as urls from './oldReportsUrls'
import { PaymentTypesOptions, TransactionTypeOption } from '../../common/constants'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import BranchwiseCollectionExcel from './Branchwise/BranchwiseCollectionExcel'
import { paymentModes } from '../../common/paymentsMode'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');

const BranchwiseCollectionNew = (props) => {
    const {
        data: { common, reports },
        getBranchWiseCollectionData,
        getOwnChildBranches,
    } = props
    const { loginData, roleRights } = common
    const [companySettings] = useAtom(companySettingsAtom)
    const UseToPayAsCOD = companySettings?.UseToPayAsCOD
    const { ownChildBranches } = reports
    const [generatereport, setGeneratereport] = useState(0)
    const [tableData, setTableData] = useState([])
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [selBranch, setSelBranch] = useState('')
    const [selTransactionType, setSelTransactionType] = useState([])
    const [selPaymentType, setSelPaymentType] = useState([])
    const [isPdfLoading, setIsPdfLoading] = useState(false)
    const [resetFlag, setResetFlag] = useState(false)
    const [showAlert, setShowAlert] = useState({
        show: false,
        message: ''
    })
    const [showTable, setShowTable] = useState(false)
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const [filterData, setFilterData] = useState({
        FromDate: '',
        ToDate: '',
        CompanyName: '',
        BranchName: '',
        transaction: '',
        payment: '',
    });
    const reportViewData = [
        { view: 'Detailed', id: 0 },
        { view: 'Summary', id: 1 },
    ]
    const [reportView, setReportView] = useState(reportViewData[0])
    const [disableBtn, setDisableBtn] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    const [paymentTypeOpt, setPaymentTypeOpt] = useState([])
    const [columnDefsForSummary, setColumnDefsForSummary] = useState([]);
    // for Header columns' title
    const columnDetailedBok = [
        { headerName: 'Serial Number', exportHead: 'Serial Number', field: 'SNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '50px', textAlign: 'center' }, isSortIcon: false },
        { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' }, isSortIcon: true },
        { headerName: 'Booking Date', exportHead: 'Booking Date', field: 'Date', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' }, isSortIcon: true },
        { headerName: 'Source', exportHead: 'Source', field: 'SourceCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' }, isSortIcon: true },
        { headerName: 'Destination', exportHead: 'Destination', field: 'DestinationCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' }, isSortIcon: true },
        { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' }, isSortIcon: true },
        { headerName: 'Consignment Type', exportHead: 'Consignment Type', field: 'ConsignmentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' }, isSortIcon: true },
        { headerName: 'Units', exportHead: 'Units', field: 'Quantity', xlCol: { dataType: 'quantity', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'Freight', exportHead: 'Freight', field: 'Freight', xlCol: { dataType: 'quantity', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'Other Charges', exportHead: 'Other Charges', field: 'OtherCharges', xlCol: { dataType: 'quantity', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'Booking GST', exportHead: 'Booking GST', field: 'GST', xlCol: { dataType: 'quantity', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'NetAmount', xlCol: { dataType: 'quantity', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'Remarks', exportHead: 'Remarks', field: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' }, isSortIcon: true },
    ]
    const columnDetailedDel = [
        { headerName: 'Serial Number', exportHead: 'Serial Number', field: 'SNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '50px', textAlign: 'center' } },
        { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Delivery Date', exportHead: 'Delivery Date', field: 'Date', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Source', exportHead: 'Source', field: 'SourceCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Destination', exportHead: 'Destination', field: 'DestinationCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Consignment Type', exportHead: 'Consignment Type', field: 'ConsignmentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Units', exportHead: 'Units', field: 'Quantity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Total LR Amt', exportHead: 'Total LR Amt', field: 'Freight', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Net Charge', exportHead: 'Net Charge', field: 'OtherCharges', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Delivery GST', exportHead: 'Delivery GST', field: 'GST', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'NetAmount', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Remarks', exportHead: 'Remarks', field: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
    ]
    const columnDetailedRef = [
        { headerName: 'Serial Number', exportHead: 'Serial Number', field: 'SNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '50px', textAlign: 'center' } },
        { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Refund Date', exportHead: 'Date', field: 'Refund Date', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Source', exportHead: 'Source', field: 'SourceCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Destination', exportHead: 'Destination', field: 'DestinationCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Consignment Type', exportHead: 'Consignment Type', field: 'ConsignmentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Units', exportHead: 'Units', field: 'Quantity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Freight', exportHead: 'Freight', field: 'Freight', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Other Charges', exportHead: 'Other Charges', field: 'OtherCharges', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Refund GST', exportHead: 'Refund GST', field: 'GST', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'NetAmount', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Remarks', exportHead: 'Remarks', field: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
    ]
    const columnSummaryDefs = [
        { headerName: 'Transactions', exportHead: 'Transactions', field: 'transaction', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' }, isSortIcon: true },
        { headerName: 'Paid', exportHead: 'Paid', field: 'PaidAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'Paid Manual', exportHead: 'Paid Manual', field: 'PaidManAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'ToPay', exportHead: 'ToPay', field: 'TopayAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'ToPay Manual', exportHead: 'ToPay Manual ', field: 'TopayManAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'ToPay DDDV', exportHead: 'ToPay DDDV', field: 'DDDVAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'On Account', exportHead: 'On Account', field: 'OnAccAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'COD', exportHead: 'COD', field: 'CODAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'Self Booking', exportHead: 'Self Booking', field: 'SelfAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'FOC', exportHead: 'FOC', field: 'FOCAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
        { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'totalAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' }, isSortIcon: true },
    ];
    const filterHeader = [
        { headerName: 'Branch', dataKey: "BranchName", colSpan: 4 },
        { headerName: 'Transaction Type', dataKey: "transaction", colSpan: 4 },
        { headerName: 'Payment Type', dataKey: "payment", colSpan: generatereport ? 3 : 5 },
    ]
    const selectedTransactionText = selTransactionType.length === 0
        ? ''
        : selTransactionType.length !== TransactionTypeOption.length
            ? selTransactionType.reduce((data, obj) => {
                if (obj.id !== 'All') {
                    data.push(obj.Name)
                }
                return data
            }, []).join(', ')
            : 'All'
    const selectedPaymentText = selPaymentType.length === 0
        ? ''
        : selPaymentType.length !== paymentTypeOpt.length
            ? selPaymentType.reduce((data, obj) => {
                if (obj.typeId !== 0) {
                    data.push(obj.name)
                }
                return data
            }, []).join(', ')
            : 'All'
    const criteriaHeaders = [
        { field: 'selectedCompany', header: 'Selected Company', textAlign: 'left' },
        { field: 'fromDate', header: 'From Collection Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Collection Date', textAlign: 'left' },
        { field: 'selBranch', header: 'Branch', textAlign: 'left' },
        { field: 'transactionType', header: 'Transaction Type', textAlign: 'left' },
        { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
        { field: 'selReportView', header: 'Report View', textAlign: 'left' },
    ]
    const criteriaData = {
        selectedCompany: loginData?.strCompanyName || '',
        fromDate: fromDate.format('DD-MM-YYYY') || '',
        toDate: toDate.format('DD-MM-YYYY') || '',
        selBranch: selBranch?.BranchName || '',
        transactionType: selectedTransactionText,
        paymentType: selectedPaymentText,
        selReportView: reportView?.view || '',
        dataType: 'entry',
    }
    useEffect(() => {
        let updatedColumns = columnSummaryDefs.map(col => ({ ...col }));
        if (UseToPayAsCOD === 1) {
            updatedColumns = updatedColumns.map(col => {
                switch (col.field) {
                    case 'TopayAmt':
                        return { ...col, headerName: 'COD', exportHead: 'COD' };
                    case 'TopayManAmt':
                        return { ...col, headerName: 'COD Manual', exportHead: 'COD Manual' };
                    case 'DDDVAmt':
                        return { ...col, headerName: 'COD DDDV', exportHead: 'COD DDDV' };
                    default:
                        return col;
                }
            });
            updatedColumns = updatedColumns.filter(col => col.field !== 'CODAmt');
        }
        setColumnDefsForSummary(updatedColumns);
    }, [UseToPayAsCOD]);
    useEffect(() => {
        if (!isEmpty(roleRights) && !isEmpty(loginData)) {
            setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
            setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
        }
    }, [roleRights, loginData])
    useEffect(() => {
        if (!isEmpty(roleRights)) {
            let updatedPayTypeData = [];
            if ((roleRights?.Table) && roleRights.Table.length > 0) {
                const obj = roleRights?.Table.filter((val) => val.BookingRightsID == 1)?.[0] || {};
                const payTypeData = paymentModes.filter((val) => obj[val.roleRightsId] === 1);
                updatedPayTypeData = [{ typeId: 0, type: "ALL", name: "All", f: 'none', b: 'none', isEnabled: true }, ...payTypeData];
            } else {
                updatedPayTypeData = [{ typeId: 0, type: "ALL", name: "All", f: 'none', b: 'none', isEnabled: true }, ...paymentModes];
            }
            if (UseToPayAsCOD === 1) {
                const toPayIndex = updatedPayTypeData.findIndex(item => item.typeId === 2);
                const codOption = updatedPayTypeData.find(item => item.typeId === 4);
                if (toPayIndex !== -1 && codOption) {
                    updatedPayTypeData[toPayIndex] = {
                        ...codOption,
                        typeId: 2,
                        name: "COD",
                        roleRightsId: "COD"
                    };
                }
                updatedPayTypeData = updatedPayTypeData.filter(item => item.typeId !== 4);
            }
            setPaymentTypeOpt(updatedPayTypeData);
        }
    }, [roleRights, UseToPayAsCOD]);
    useEffect(() => {
        focusElemnt(id.fromDate)
    }, [])
    const handleClick1 = (type) => {
        if (selBranch === '' || selBranch === ' ') {
            setShowAlert({ show: true, message: "Please select Branch" })
        } else if (selTransactionType.length === 0) {
            setShowAlert({ show: true, message: " Please select Transaction" })
        } else if (selPaymentType.length === 0) {
            setShowAlert({ show: true, message: " Please select Payment Type" })
        } else if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
            setShowAlert({ show: true, message: "This report cannot be taken for more than 31 days" })
        } else if (reportView === '' || reportView === ' ') {
            setShowAlert({ show: true, message: " Please select Report View" })
        } else {
            let url = urls.branchWiseCollection
            const urlData = urls.branchWiseCollectionParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.intCompanyId = loginData.intCompanyID
            urlData.FromDate = fromDate.format('YYYY-MM-DD')
            urlData.ToDate = toDate.format('YYYY-MM-DD')
            urlData.BranchId = selBranch.BranchID
            urlData.Summary = type.id
            urlData.BranchName = selBranch.BranchName
            urlData.intAllowExportToExcel = 1
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }
    }

    useEffect(() => {
        if (!isEmpty(loginData)) {
            const branchData = {
                intUserID: 0,
                intCompanyID: loginData?.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
        }
    }, [loginData])

    const [defaultBranch, setDefaultBranch] = useState('')
    useEffect(() => {
        if (ownChildBranches.length > 0) {
            let filterData = ownChildBranches.filter((obj) => obj.BranchID == loginData?.intBranchID)
            if (filterData.length > 0) {
                setDefaultBranch(filterData[0].BranchName)
                setSelBranch(filterData[0])
            }
        }
    }, [ownChildBranches])
 
    //Generate report
    const generateBanchWiseReport = () => {
        setTableData([])
        setShowTable(false);
        setGeneratereport(reportView.id)
        if (selBranch === '' || selBranch === ' ') {
            setShowAlert({ show: true, message: "Please select Branch" })
        } else if (selTransactionType.length === 0) {
            setShowAlert({ show: true, message: " Please select Transaction" })
        } else if (selPaymentType.length === 0) {
            setShowAlert({ show: true, message: " Please select Payment Type" })
        } else if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
            setShowAlert({ show: true, message: "This report cannot be taken for more than 31 days" })
        } else if (reportView === '' || reportView === ' ') {
            setShowAlert({ show: true, message: " Please select Report View" })
        } else {
            setTableData([])
            setIsPdfLoading(false);
            const body = {
                CompanyID: loginData.intCompanyID,
                BranchID: selBranch.BranchID,
                UserID: loginData.intUserID,
                dtFrom: moment(new Date(fromDate)).format("YYYY-MM-DD"),
                dtTo: moment(new Date(toDate)).format("YYYY-MM-DD"),
                Modes: selTransactionType.length != TransactionTypeOption.length ? selTransactionType.reduce((data, obj) => { if (obj.id !== 'All') { data.push(obj.id); } return data }, []).join('^') : 'All',
                //PaymentTypeIDs: selPaymentType.length != PaymentTypesOptions.length ? selPaymentType.reduce((data, obj) => { if (obj.id !== 0) { data.push(obj.id); } return data }, []).join('^') : 0,
                PaymentTypeIDs: selPaymentType.length != paymentTypeOpt.length ? selPaymentType.reduce((data, obj) => { if (obj.typeId !== 0) { data.push(obj.typeId); } return data }, []).join('^') : 0,

            }
            setFilterData((prev) => ({
                ...prev,
                FromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
                ToDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
                CompanyName: loginData.strCompanyName,
                BranchName: selBranch.BranchName,
                transaction: selTransactionType.length != TransactionTypeOption.length ? selTransactionType.reduce((data, obj) => { if (obj.id !== 'All') { data.push(obj.Name); } return data }, []).join(',') : 'All',
                payment: selPaymentType.length != paymentTypeOpt.length ? selPaymentType.reduce((data, obj) => { if (obj.typeId !== 0) { data.push(obj.name); } return data }, []).join(',') : "All",
                //  payment: selPaymentType.length != PaymentTypesOptions.length ? selPaymentType.reduce((data, obj) => { if (obj.id !== 0) { data.push(obj.Name); } return data }, []).join(',') : "All",
            }))

            getBranchWiseCollectionData(body).then((val) => {
                if (reportView.view === 'Summary') {
                    let reportData = formatData(val.Data, reportView, selTransactionType)
                    let mainHeader = columnDefsForSummary.map((val) => ({
                        ...val,
                        align: val.headerSx.textAlign,
                        header: val.headerName,
                        export: val.exportHead,
                        weight: 80
                    }))
                    let reportPayload = {
                        reportName: 'Branchwise Collection Report (Summary)',
                        criteriaHeaders: criteriaHeaders,
                        criteriaData: [criteriaData],
                        tableData: reportData,
                        mainHeader: mainHeader,
                        hideHeader: true
                    }
                    const rid = Date.now().toString()

                    if (!window.generatedReports) {
                        window.generatedReports = {}
                    }

                    window.generatedReports[rid] = reportPayload

                    window.open(`/view-report?rid=${rid}`, "_blank")
                } else {
                    const updatedData = {
                        ...val,
                        Data: {
                            ...val.Data,
                            Table: val.Data.Table.map((item) => ({
                                ...item,
                                PaymentType:
                                    UseToPayAsCOD === 1 && item.PaymentType === "To-Pay"
                                        ? "COD"
                                        : item.PaymentType,
                            })),
                        },
                    };
                    let reportData = formatDataTwo(updatedData.Data, selTransactionType);
                    let mainHeader = columnDetailedBok.map((val) => ({
                        ...val,
                        align: val.headerSx.textAlign,
                        header: val.headerName,
                        export: val.exportHead,
                        weight: 80
                    }))
                    let reportPayload = {
                        reportName: 'Branchwise Collection Report (Detailed)',
                        criteriaHeaders: criteriaHeaders,
                        criteriaData: [criteriaData],
                        tableData: reportData,
                        mainHeader: mainHeader,
                        hideHeader: true,
                        serialNokey :'SNo',
                    }
                    const rid = Date.now().toString()

                    if (!window.generatedReports) {
                        window.generatedReports = {}
                    }

                    window.generatedReports[rid] = reportPayload

                    window.open(`/view-report?rid=${rid}`, "_blank")
                }
            })
        }
    }
   
    const fmt = (n) => Number(n || 0).toLocaleString('en-IN')

    const formatRowNumbers = (row) => {
        if (!['entry', 'total'].includes(row.dataType)) return row

        return Object.keys(row).reduce((acc, k) => {
            acc[k] =
                typeof row[k] === 'number'
                    ? fmt(row[k])
                    : row[k]
            return acc
        }, {})
    }
    const formatData = (data, type, txnType) => {
        if (type.id) {
            let summaryData = []
            let bookingData = [];
            let deliveryData = [];
            let refundData = [];
            const activeSummaryColumns = columnDefsForSummary.length
                ? columnDefsForSummary
                : columnSummaryDefs
            const summaryFields = activeSummaryColumns.map((col) => col.field)
            const leftSubHeaderSpan = Math.min(6, summaryFields.length)
            const rightSubHeaderField = summaryFields[leftSubHeaderSpan]
            const rightSubHeaderSpan = rightSubHeaderField
                ? summaryFields.length - leftSubHeaderSpan
                : 0

            let totalBookingAndDelivery = {
                PaidAmt: 0,
                PaidManAmt: 0,
                TopayAmt: 0,
                TopayManAmt: 0,
                DDDVAmt: 0,
                OnAccAmt: 0,
                CODAmt: 0,
                SelfAmt: 0,
                FOCAmt: 0,
                totalAmt: 0,
            }

            let totalRow = {
                PaidAmt: 0,
                PaidManAmt: 0,
                TopayAmt: 0,
                TopayManAmt: 0,
                DDDVAmt: 0,
                OnAccAmt: 0,
                CODAmt: 0,
                SelfAmt: 0,
                FOCAmt: 0,
                totalAmt: 0,
            }

            let printHeader = {
                transaction: `Summary View (${data.Table2[0].Branchname})`,
                dataType: 'header',
                colSpan: { transaction: summaryFields.length },
                align: { transaction: 'left' },disableSortIcon: true 
            }

            let subHeaderRow = {
                transaction: `State: ${data.Table2[0].Statename}`,
                dataType: 'subHeader',
                ...(rightSubHeaderField ? { [rightSubHeaderField]: `City: ${data.Table2[0].Cityname}` } : {}),
                colSpan: {
                    transaction: leftSubHeaderSpan,
                    ...(rightSubHeaderField ? { [rightSubHeaderField]: rightSubHeaderSpan } : {}),
                },
                align: {
                    transaction: 'left',
                    ...(rightSubHeaderField ? { [rightSubHeaderField]: 'right' } : {}),
                },
            }

            let headerRow = {
                dataType: 'header',
                transaction: 'Transactions',
                PaidAmt: 'Paid',
                PaidManAmt: 'Paid Manual',
                TopayAmt: UseToPayAsCOD === 1 ? 'COD' : 'ToPay',
                TopayManAmt: UseToPayAsCOD === 1 ? 'COD Manual' : 'ToPay Manual',
                DDDVAmt: UseToPayAsCOD === 1 ? 'COD DDDV' : 'ToPay DDDV',
                OnAccAmt: 'On Account',
                CODAmt: 'COD',
                SelfAmt: 'Self Booking',
                FOCAmt: 'FOC',
                totalAmt: 'Total Amount'
            };

            if (UseToPayAsCOD === 1 && headerRow.hasOwnProperty('CODAmt')) {
                delete headerRow.CODAmt;
            }
            data.Table1.forEach((val, index) => {
                const totatAmt = val.PaidAmt + val.PaidManAmt + val.TopayAmt + val.TopayManAmt + val.OnAccAmt + val.CODAmt + val.SelfAmt + val.FOCAmt;
                if (val.TYPE === "R") {
                    refundData.push({ dataType: 'entry', ...val, transaction: `${val.TransactionType}(C)`, totalAmt: totatAmt })
                } else if (val.TYPE === 'D') {
                    deliveryData.push({ dataType: 'entry', ...val, transaction: `${val.TransactionType}(B)`, totalAmt: totatAmt })
                } else if (val.TYPE === 'B') {
                    bookingData.push({ dataType: 'entry', ...val, transaction: `${val.TransactionType}(A)`, totalAmt: totatAmt })
                }

                totalRow = {
                    dataType: 'total',
                    PaidAmt: val.TYPE == 'R' ? totalRow.PaidAmt - val.PaidAmt : totalRow.PaidAmt + val.PaidAmt,
                    PaidManAmt: val.TYPE == 'R' ? totalRow.PaidManAmt - val.PaidManAmt : totalRow.PaidManAmt + val.PaidManAmt,
                    TopayAmt: val.TYPE == 'R' ? totalRow.TopayAmt - val.TopayAmt : totalRow.TopayAmt + val.TopayAmt,
                    TopayManAmt: val.TYPE == 'R' ? totalRow.TopayManAmt - val.TopayManAmt : totalRow.TopayManAmt + val.TopayManAmt,
                    DDDVAmt: val.TYPE == 'R' ? totalRow.DDDVAmt - val.DDDVAmt : totalRow.DDDVAmt + val.DDDVAmt,
                    OnAccAmt: val.TYPE == 'R' ? totalRow.OnAccAmt - val.OnAccAmt : totalRow.OnAccAmt + val.OnAccAmt,
                    CODAmt: val.TYPE == 'R' ? totalRow.CODAmt - val.CODAmt : totalRow.CODAmt + val.CODAmt,
                    SelfAmt: val.TYPE == 'R' ? totalRow.SelfAmt - val.SelfAmt : totalRow.SelfAmt + val.SelfAmt,
                    FOCAmt: val.TYPE == 'R' ? totalRow.FOCAmt - val.FOCAmt : totalRow.FOCAmt + val.FOCAmt,
                    totalAmt: val.TYPE == 'R' ? totalRow.totalAmt - totatAmt : totalRow.totalAmt + totatAmt,
                }
                totalBookingAndDelivery = {
                    dataType: 'total',
                    PaidAmt: val.TYPE == 'R' ? totalBookingAndDelivery.PaidAmt : totalBookingAndDelivery.PaidAmt + val.PaidAmt,
                    PaidManAmt: val.TYPE == 'R' ? totalBookingAndDelivery.PaidManAmt : totalBookingAndDelivery.PaidManAmt + val.PaidManAmt,
                    TopayAmt: val.TYPE == 'R' ? totalBookingAndDelivery.TopayAmt : totalBookingAndDelivery.TopayAmt + val.TopayAmt,
                    TopayManAmt: val.TYPE == 'R' ? totalBookingAndDelivery.TopayManAmt : totalBookingAndDelivery.TopayManAmt + val.TopayManAmt,
                    DDDVAmt: val.TYPE == 'R' ? totalBookingAndDelivery.DDDVAmt : totalBookingAndDelivery.DDDVAmt + val.DDDVAmt,
                    OnAccAmt: val.TYPE == 'R' ? totalBookingAndDelivery.OnAccAmt : totalBookingAndDelivery.OnAccAmt + val.OnAccAmt,
                    CODAmt: val.TYPE == 'R' ? totalBookingAndDelivery.CODAmt : totalBookingAndDelivery.CODAmt + val.CODAmt,
                    SelfAmt: val.TYPE == 'R' ? totalBookingAndDelivery.SelfAmt : totalBookingAndDelivery.SelfAmt + val.SelfAmt,
                    FOCAmt: val.TYPE == 'R' ? totalBookingAndDelivery.FOCAmt : totalBookingAndDelivery.FOCAmt + val.FOCAmt,
                    totalAmt: val.TYPE == 'R' ? totalBookingAndDelivery.totalAmt : totalBookingAndDelivery.totalAmt + totatAmt,
                }
            })
            let findAllOpt = selTransactionType.length == TransactionTypeOption.length;
            let findBokOpt = selTransactionType.find((obj) => obj.id == 'B');
            let findDelOpt = selTransactionType.find((obj) => obj.id == 'D');
            let findRefOpt = selTransactionType.find((obj) => obj.id == 'R');
            summaryData.push(printHeader, subHeaderRow, headerRow)
            let noRowData = { dataType: 'entry', PaidAmt: 0, PaidManAmt: 0, TopayAmt: 0, TopayManAmt: 0, DDDVAmt: 0, OnAccAmt: 0, CODAmt: 0, SelfAmt: 0, FOCAmt: 0, totalAmt: 0 }
            if (findAllOpt || findBokOpt !== undefined) {
                if (bookingData.length > 0) {
                    summaryData.push(...bookingData)
                } else {
                    summaryData.push({ ...noRowData, transaction: 'Booking(A)' })
                }
            }
            if (findAllOpt || findDelOpt !== undefined) {
                if (deliveryData.length > 0) {
                    summaryData.push(...deliveryData)
                } else {
                    summaryData.push({ ...noRowData, transaction: 'Delivery(B)' })
                }
            }
            if (findAllOpt || findBokOpt !== undefined || findDelOpt !== undefined) {
                summaryData.push({ dataType: 'total', transaction: `Total Collection ${`(${findBokOpt != undefined ? 'A' : ''}${findDelOpt != undefined ? findBokOpt != undefined ? '+B' : 'B' : ''})`} `, colSpan: { transaction: 1 }, align: { transaction: 'left' }, ...totalBookingAndDelivery })
            }
            if (findAllOpt || findRefOpt !== undefined) {
                if (refundData.length > 0) {
                    summaryData.push(...refundData)
                } else {
                    summaryData.push({ ...noRowData, transaction: 'Refund(C)' })
                }
                summaryData.push({ dataType: 'total', transaction: `Net Collection ${findAllOpt ? '(A+B-C)' : `(${findBokOpt != undefined ? 'A' : ''}${findDelOpt != undefined ? findBokOpt != undefined ? '+B' : 'B' : ''}${findRefOpt != undefined ? findRefOpt != undefined ? '-C' : 'C' : ''})`} `, colSpan: { transaction: 1 }, align: { transaction: 'left' }, ...totalRow })
            }
            let finalData = summaryData.map(formatRowNumbers)
            return finalData
        }
    }

    const formatDataTwo = (data, txnType) => {
        if (!data || !data.Table) return

        const groupBy = (array, key) => {
            return array.reduce((acc, item) => {
                const groupKey = item[key] || 'UNKNOWN'
                if (!acc[groupKey]) acc[groupKey] = []
                acc[groupKey].push(item)
                return acc
            }, {})
        }

        const groupedByPaymentMode = groupBy(data.Table, 'PaymentMode')
        let finalData = []

        let grandTotal = {
            dataType: 'total',
            Quantity: 0,
            Freight: 0,
            OtherCharges: 0,
            GST: 0,
            NetAmount: 0,
        }

        const transactionTypes = {
            B: 'Booking',
            D: 'Delivery',
            R: 'Refund',
        }

        Object.entries(groupedByPaymentMode).forEach(([paymentMode, records]) => {
            let paymentModeSection = []

            Object.entries(transactionTypes).forEach(([transCode, label]) => {
                if (!txnType.find((obj) => obj.id === transCode || obj.id === 'All')) return

                const filtered = records.filter((item) => item.TransType === transCode)
                if (filtered.length === 0) return

                let total = {
                    dataType: 'total',
                    Quantity: 0,
                    Freight: 0,
                    OtherCharges: 0,
                    GST: 0,
                    NetAmount: 0,
                }

                const rows = filtered.map((val, i) => {
                    const dateField = transCode === 'B' ? val.BookingDate : val.TransDateTime
                    const formattedDate = moment(new Date(dateField)).format('DD-MMM-YY')

                    total.Quantity += val.Quantity
                    total.Freight += val.Freight
                    total.OtherCharges += val.OtherCharges
                    total.GST += val.GST
                    total.NetAmount += val.NetAmount

                    return {
                        dataType: 'entry',
                        SNo: i + 1,
                        ...val,
                        Date: formattedDate,
                    }
                })
                if (transCode === 'R') {
                    grandTotal.Quantity -= total.Quantity
                    grandTotal.Freight -= total.Freight
                    grandTotal.OtherCharges -= total.OtherCharges
                    grandTotal.GST -= total.GST
                    grandTotal.NetAmount -= total.NetAmount
                } else {
                    grandTotal.Quantity += total.Quantity
                    grandTotal.Freight += total.Freight
                    grandTotal.OtherCharges += total.OtherCharges
                    grandTotal.GST += total.GST
                    grandTotal.NetAmount += total.NetAmount
                }

                const branchSubHeading = {
                    dataType: 'subHeader',
                    SNo: `Branch: ${data.Table2[0]?.Branchname}`,
                    DestinationCity: `State: ${data.Table2[0]?.Statename}`,
                    Freight: `City Name: ${data.Table2[0]?.Cityname}`,
                    colSpan: { SNo: 4, DestinationCity: 4, Freight: 5 },
                    align: { SNo: 'left', DestinationCity: 'center', Freight: 'right' },
                }

                const transactionSubHeading = {
                    dataType: 'subHeader',
                    SNo: `Transactions: ${label}`, colSpan: { SNo: 13 }, align: { SNo: 'left' },
                }

                const header = {
                    dataType: 'header',
                    ...(transCode === 'B'
                        ? {
                            isBooking: true,
                            SNo: 'S/N',
                            LRNO: 'LR No',
                            Date: 'Bkg. Date',
                            SourceCity: 'Source',
                            DestinationCity: 'Destination',
                            PaymentType: 'Pymt. Type',
                            ConsignmentType: 'Cons. Type',
                            Quantity: 'Units',
                            Freight: 'Freight',
                            OtherCharges: 'Other Chrgs.',
                            GST: 'Bkg.GST',
                            NetAmount: 'Total Amt.',
                            Remarks: 'Remarks',
                        }
                        : transCode === 'D'
                            ? {
                                isDelivery: true,
                                SNo: 'S/N',
                                LRNO: 'LR No',
                                Date: 'Del. Date',
                                SourceCity: 'Source',
                                DestinationCity: 'Destination',
                                PaymentType: 'Pymt. Type',
                                ConsignmentType: 'Cons. Type',
                                Quantity: 'Units',
                                Freight: 'Total LR Amt.',
                                OtherCharges: 'Net Chrgs.',
                                GST: 'Delivery GST',
                                NetAmount: 'Total Amt.',
                                Remarks: 'Remarks',
                            }
                            : {
                                isRefund: true,
                                SNo: 'S/N',
                                LRNO: 'LR No',
                                Date: 'Refund Date',
                                SourceCity: 'Source',
                                DestinationCity: 'Destination',
                                PaymentType: 'Pymt. Type',
                                ConsignmentType: 'Cons. Type',
                                Quantity: 'Units',
                                Freight: 'Freight',
                                OtherCharges: 'Other Chrgs.',
                                GST: 'Refund GST',
                                NetAmount: 'Total Amt.',
                                Remarks: 'Remarks',
                            }),
                }

                paymentModeSection.push(header, branchSubHeading, transactionSubHeading, ...rows, {
                    SNo: `Total Amount: ${label}`,
                    colSpan: { SNo: 7 },
                    align: { SNo: 'right' },
                    ...total,
                })
            })

            if (paymentModeSection.length > 0) {
                finalData.push({
                    dataType: 'subHeader',
                    SNo: `Payment Mode:${paymentMode}`, colSpan: { SNo: 13 }, align: { SNo: 'left' },
                })
                finalData.push(...paymentModeSection)
            }
        })
        const SupHeading = {
            SNo: `Detailed View (Individual Branch)`,
            dataType: 'header',
            colSpan: { SNo: 13 }, 
            align: { SNo: 'left' },
        }
        finalData.push({
            SNo: `Total Amount: ${data.Table2[0]?.Branchname}`,
            colSpan: { SNo: 7 },
            align: { SNo: 'right' },
            ...grandTotal,
        })
        let detailedData = [SupHeading, ...finalData]
        return detailedData.map(formatRowNumbers)
    }


    //handle Close Alert
    const handleCloseAlert = () => {
        setShowAlert({ show: false, message: '' })
    }
    const reset = () => {
        setResetFlag(!resetFlag)
        setSelBranch('')
        setSelPaymentType([])
        setSelTransactionType([])
    }
    const onKeyDown1 = (e) => {
        navigation3(e, showTable ? isPdfLoading ? "backbtn" : disableExcel ? 'exportPdfBtn' : "excepbtn" : id.fromDate, id.reportView, generateBanchWiseReport)
    }
    return (
        <Item sx={{ padding: '0' }} className="reports">
            <ReportHeading reportName={'Branchwise Collection'} />
            <Box sx={sx.reportFlex}>
                <Item sx={sx.itemsxGrow}>
                    <DropDownOA
                        id={id.selectCompnay}
                        label={lb.select_company}
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} id={id.goButton} className="btn btn-primary">
                        GO
                    </Button>
                </Item>
                <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
                    <Datepicker
                        name={'from_collection_date'}
                        label={lb.from_collection_date}
                        id={id.fromDate}
                        width="100%"
                        dateChange={(date) => {
                            setFromDate(date)
                            focusElemnt(id.toDate)
                        }}
                    />
                </Item>
                <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
                    <Datepicker
                        label={lb.to_collection_date}
                        id={id.toDate}
                        width="100%"
                        dateChange={(date) => {
                            setToDate(date)
                            focusElemnt(id.selectBranch)
                        }}
                    />
                </Item>
                <Item sx={{ ...sx.itemsxGrow, flexDirection: 'column', alignItems: 'start' }}>
                    <DropDownOA
                        label={lb.selectBranch}
                        id={id.selectBranch}
                        defaultvalue={defaultBranch}
                        data={roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 ? ownChildBranches.filter((val) => val.SourceBranchID == loginData?.intBranchCityID) : ownChildBranches || []}
                        dataKey={`BranchName`}
                        searchPlaceholder={`Search By Branch`}
                        idKey={`BranchID`}
                        disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                        width="100%"
                        resetFlag={resetFlag}
                        onSelect={(val) => setSelBranch(val)}
                        onReset={() => setSelBranch('')}
                        prevId={id.toDate}
                        nextId={id.reportView}
                    />
                </Item>
            </Box>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
                <Item sx={{ ...sx.itemsx, flexDirection: 'column', alignItems: 'start' }}>
                    <DropDownMultiSelect
                        label={lb.transactionType}
                        id={id.transactionType}
                        data={TransactionTypeOption}
                        searchPlaceholder={`Search By Transaction`}
                        HasAllSelect={true}
                        resetFlag={resetFlag}
                        idKey={`id`}
                        dataKey={`Name`}
                        onSelect={(val) => {
                            setSelTransactionType(val)
                        }}
                        nextId={id.reportView}
                        prevId={id.selectBranch}
                    />
                </Item>
                <Item sx={{ ...sx.itemsx, flexDirection: 'column', alignItems: 'start' }}>
                    <DropDownMultiSelect
                        label={lb.paymentType}
                        id={id.paymentBookingType}
                        data={paymentTypeOpt}
                        // data={PaymentTypesOptions}//
                        searchPlaceholder={`Search By Payment`}
                        HasAllSelect={true}
                        resetFlag={resetFlag}
                        // dataKey={`Name`}
                        dataKey={`name`}
                        idKey={'typeId'}
                        // idKey={`id`}
                        onSelect={(val) => {
                            setSelPaymentType(val)
                        }}
                        nextId={id.reportView}
                        prevId={id.transactionType}
                    />

                </Item>
                <Item sx={{ ...sx.itemsx, flexDirection: 'column', alignItems: 'start' }}>
                    <DropDownOA
                        defaultvalue={reportView?.view}
                        data={reportViewData}
                        width="100%"
                        searchPlaceholder={`Search By View`}
                        label={lb.reportView}
                        id={id.reportView}
                        tabIndex="2"
                        dataKey={`view`}
                        idKey={`id`}
                        onSelect={(value) => setReportView(value)}
                        onReset={() => setReportView('')}
                        prevId={id.selectBranch}
                        nextId={id.reportmainButton}
                    />
                </Item>
                <Item sx={sx.itemsx} onKeyDown={(e) => onKeyDown1(e)}>
                    <SplitButton
                        options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                        hideToggle={false}
                        id1={id.reportmainButton}
                        onClick1={generateBanchWiseReport}
                        onClick2={() => {
                            handleClick1(reportView)
                        }}
                    />
                </Item>
                <Item sx={{ ...sx.itemsx }} onClick={reset} >
                    <RefreshSvg />
                </Item>
            </Box>
            {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
        </Item>
    )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchList, getBranchWiseCollectionData, getOwnChildBranches }
export default connect(mapStateToProps, mapDispatchToProps)(BranchwiseCollectionNew)
